import { createFileRoute, Link } from "@tanstack/react-router";

import { Page, QuoteForm } from "../components/site";
import { SITE, diensten, plaatsen } from "../lib/seo-data";

const title = "Elektricien in jouw plaats - 25 steden | offerto";
const description =
  "Vind een erkende elektricien in Amsterdam, Rotterdam, Utrecht, Eindhoven en 21 andere plaatsen. Vergelijk gratis offertes per stad en per klus.";

export const Route = createFileRoute("/plaatsen/")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE}/plaatsen` },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: `${SITE}/plaatsen` }],
  }),
  component: Plaatsen,
});

function Plaatsen() {
  return (
    <Page
      title="Elektricien per plaats"
      intro="Vind betrouwbare elektriciens en vakmensen in jouw buurt. Kies je stad, bekijk lokale richtprijzen en vergelijk meerdere offertes uit jouw regio."
    >
      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {plaatsen.map((p) => (
          <Link
            key={p.slug}
            to="/plaatsen/$plaats"
            params={{ plaats: p.slug }}
            className="rounded-lg border border-border bg-card p-5 transition-colors hover:border-primary"
          >
            <h2 className="text-lg font-bold">Elektricien {p.naam}</h2>
            <p className="mt-1 text-xs uppercase tracking-wide text-muted-foreground">
              {p.provincie} · {p.inwoners} inwoners
            </p>
            <p className="mt-2 text-sm text-muted-foreground">{p.wijken.join(", ")}</p>
          </Link>
        ))}
      </div>

      <h2 className="mt-16 text-2xl font-bold">Kosten per klus</h2>
      <p className="mt-2 text-muted-foreground">
        Bekijk landelijke richtprijzen voordat je een plaats kiest.
      </p>
      <ul className="mt-5 grid gap-2 text-sm sm:grid-cols-2 lg:grid-cols-3">
        {diensten.map((d) => (
          <li key={d.slug}>
            <Link
              to="/elektricien/$dienst"
              params={{ dienst: d.slug }}
              className="text-muted-foreground hover:text-primary"
            >
              Wat kost {d.naam.toLowerCase()}? {d.prijs}
            </Link>
          </li>
        ))}
      </ul>

      <div className="mt-12">
        <QuoteForm />
      </div>
    </Page>
  );
}
